import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorContainer } from "./error-container";
import { ErrorHeader } from "./error-header";
const DefaultContainer = ({ children, className, }) => _jsx("div", { className: className, children: children });
const AppErrorLayout = ({ Container = DefaultContainer, containerProps, logo, title, subtitle, }) => {
    return (_jsxs(Container, { className: "grid gap-8", ...(containerProps ?? {}), children: [logo, _jsx(ErrorContainer, { children: _jsx(ErrorHeader, { title: title, subtitle: subtitle }) })] }));
};
export const UnhandledAppError = (props) => {
    return _jsx(AppErrorLayout, { ...props });
};
export const NotFoundAppError = ({ title = "Page not found", subtitle = "There was a problem finding the page you were looking for.", ...props }) => {
    return _jsx(AppErrorLayout, { ...props, title: title, subtitle: subtitle });
};
export const DefaultNotFoundAppError = () => _jsx(NotFoundAppError, {});
